import { navigate } from "gatsby"

import i18next, { Routes, useTranslation } from "@trueskin-web/translations"

import Card from "./card"
import mixingDropsIcon from "./images/mixingDropsIcon.svg"
import notesIcon from "./images/notesIcon.svg"
import packageIcon from "./images/packageIcon.svg"

const lines = i18next.t("Start.WelcomeBack.Steps.UVPs.items", {
  returnObjects: true,
})

const UVP = ({ imgSrc, children }) => (
  <div sx={{ pr: 4, display: "flex", columnGap: "10px" }}>
    <img src={imgSrc} alt="" width={24} height={24} />
    {children}
  </div>
)

const UVPs = () => {
  const { t } = useTranslation()

  return (
    <Card
      title={t("Start.WelcomeBack.Steps.UVPs.title")}
      status="completed"
      dataTestId="wb-steps-uvps"
      onClick={() => navigate(Routes.App.Start.ChoosePlan.url)}
    >
      <div
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "column",
          rowGap: 3,
        }}
      >
        <UVP imgSrc={packageIcon}>{lines[0]}</UVP>

        <UVP imgSrc={notesIcon}>{lines[1]}</UVP>

        <UVP imgSrc={mixingDropsIcon}>{lines[2]}</UVP>
      </div>
    </Card>
  )
}

export default UVPs
